import styled, { css } from "styled-components";
import { Lock2 } from "@styled-icons/remix-fill";
import { Settings } from "@styled-icons/material";
import { PowerOff } from "@styled-icons/fa-solid";
import { Plus } from "@styled-icons/entypo";
import { LogOut } from "@styled-icons/entypo/LogOut";
import { colors } from "constants/colors";
import { fontSize } from "constants/fontSize";

type iconButtonSize = "small" | "large";

type variantType = "primary" | "secondary";

export type IconButtonProps = {
  size: iconButtonSize;
  variant: variantType;
};

const createIconButtonStyleBySize = (size: iconButtonSize) => {
  switch (size) {
    case "small":
      return css`
        font-size: ${fontSize.xxxxsmall};
      `;
    case "large":
      return css`
        font-size: ${fontSize.xxxsmall};
      `;
    default:
      return css`
        font-size: ${fontSize.xxsmall};
      `;
  }
};

const createIconButtonStyleByVariant = (variant: variantType) => {
  switch (variant) {
    case "primary":
      return css`
        border: 0px;
        background-color: ${colors.priamry};
      `;
    case "secondary":
      return css`
        background-color: transparent;
        border: 1px solid ${colors.lightGray};
      `;
  }
};

const createIconStyleByVariant = (variant: variantType) => {
  switch (variant) {
    case "primary":
      return css`
        color: ${colors.white};
      `;
    case "secondary":
      return css`
        color: ${colors.text};
      `;
  }
};

export const StyledPowerIcon = styled(PowerOff)``;

export const StyledLockIcon = styled(Lock2)``;

export const StyledSettings = styled(Settings)``;

export const StyledPlus = styled(Plus)``;

export const StyledLogOut = styled(LogOut)``;

export const StyledIconButton = styled.button<IconButtonProps>`
  ${({ size }) => createIconButtonStyleBySize(size)}
  ${({ variant }) => createIconButtonStyleByVariant(variant)}
  padding: 1em;
  border-radius: 50%;
  :hover {
    opacity: 0.8;
    cursor: pointer;
  }
  svg {
    ${({ variant }) => createIconStyleByVariant(variant)}
    height: 5em;
  }
`;
